import type { AxiosInstance, AxiosResponse } from 'axios';

export interface School {
	datovaSchrankaId?: string;
	nazev?: string;
}

export const inforAboutStudyingQuery = async <Params>(
	axiosInstance: AxiosInstance,
	params: Params
): Promise<AxiosResponse<{ seznam: Array<School> }>> =>
	await axiosInstance.get('/api/v1/ovm', {
		params,
		headers: { 'Content-Type': 'application/json' },
	});
